import { useMutation } from '@tanstack/react-query';

import { inviteUserToParty } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useInviteUser() {
  return useMutation({
    mutationFn: ({ partyId, email }: { partyId: string; email: string }) =>
      inviteUserToParty(
        {
          params: {
            path: { party_id: partyId },
          },
          body: {
            invitees: [email],
            invitee_admins: [],
          },
        },
        wgApi,
      ),
  });
}
